<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{ title }}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>

        <div v-else>
          <CForm>
            <CRow>
              <CCol sm="3">
                <CInput
                  disabled
                  label="User"
                  invalid-feedback="User name should be filled"
                  required
                  v-model="cancellationOrderForm.user_name"
                  :is-valid="!$v.cancellationOrderForm.user_name.$invalid"
                  />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="3">
                <CInput
                  disabled
                  label="Complaint Type"
                  invalid-feedback="Name should be filled"
                  v-model="cancellationOrderForm.cancellation_order_type_name"
                  :is-valid="!$v.cancellationOrderForm.cancellation_type.$invalid"
                />
              </CCol>
              <CCol sm="3">
                <CInput
                  disabled
                  label="Order Number"
                  invalid-feedback="Order number should be filled"
                  v-model="$v.cancellationOrderForm.order_number.$model"
                  :is-valid="!$v.cancellationOrderForm.order_number.$invalid"
                />
              </CCol>
              <CCol sm="3">
                <CInput
                  disabled
                  label="Date Inserted"
                  invalid-feedback="Payment Method should be filled"
                  v-model="cancellationOrderForm.date_inserted"
                  :is-valid="!$v.cancellationOrderForm.cancellation_type.$invalid"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="3">
                <div class="form-group">
                  <label for="status_code">Status</label>
                  <model-select
                    class="form-control"
                    id="status_code"
                    :options="cancellationOrderStatusList"
                    v-model="$v.cancellationOrderForm.status.$model"
                    :isError="$v.cancellationOrderForm.status.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="$v.cancellationOrderForm.status.$invalid"
                    class="invalid-feedback-custom"
                  >Status should be filled.</div>
                </div>
              </CCol>
            </CRow>
          </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton
              color="danger"
              title="Edit"
              size="sm"
              class="text-center"
              @click="back"
            >
              <i class="fa fa-undo"></i> Back </CButton
            >&nbsp;
            <CButton
              color="info"
              title="Edit"
              size="sm"
              class="text-center"
              @click="processCancel"
            >
              <i class="fa fa-window-close"></i> Confirm Cancel Order </CButton
            >&nbsp;
            <CButton
              color="success"
              title="Detail"
              :disabled="$v.cancellationOrderForm.$invalid"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="confirmCancelOrder"
    >
      <template #header>
        <h6 class="modal-title">Process Cancel Order</h6>
      </template>
      <Loading v-if="isLoading"></Loading>

      <div v-else>
        <CForm>
          <CRow>
              <CCol lg="6">
                <CTextarea
                  label="Reason"
                  invalid-feedback="Reason should be filled"
                  v-model="$v.confirmCancelForm.reason.$model"
                  :is-valid="!$v.confirmCancelForm.reason.$invalid">
                </CTextarea>
              </CCol>
          </CRow>
        </CForm>
      </div>

      <template #footer>
        <CButton @click="closeProcessCancel" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="processCancelSubmit" :disabled="$v.confirmCancelForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
          <CTab active>
            <template slot="title">Response</template>
            <br />
            <RespondList
              :cancelOrder="cancellationOrderForm"
              :cancelOrderData="cancellationOrderDetailForm"
            ></RespondList>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../templates/Loading";
import RespondList from "./tabs/RespondList";
import { required } from "vuelidate/lib/validators";

export default {
  name: "CancelOrderDetail",
  components: { GlobalTable, Loading, RespondList },
  data() {
    return {
      title: "Cancel Order Detail",
      items: [],
      cancellationOrderdetail: [],
      cancellationOrderStatusList: [],
      cancellationOrderForm: tableInterfaces.cancellation_order,
      cancellationOrderDetailForm: tableInterfaces.cancellation_order_detail,
      isLoading: false,
      confirmCancelOrder: false,
      activeTab: 0,
      confirmCancelForm: {
        reason: null
      }
    };
  },
  validations: {
    cancellationOrderForm: {
      cancellation_type: {},
      user_name: {},
      order_number: {},
      user_code: {},
      status: {required},
    },
    confirmCancelForm: {
      reason: {required},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (id) {
      this.getDetailIssue(id);
    },
    back: function () {
      this.$router.go(-1);
    },
    resetForm: function () {
      for (var i in tableInterfaces.cancellation_order) {
        tableInterfaces.cancellation_order[i] = null;
      }
      this.cancellationOrderForm = tableInterfaces.cancellation_order;
    },
    getDetailIssue: function (id) {
      this.isLoading = true;
      this.resetForm();
      this.axios
        .get("console/cancel_order/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.cancellationOrderForm = response.data.data;
           // this.cancellationOrderForm.user_code = response.data.data.user_name;
            this.cancellationOrderDetailForm = response.data.dataDetail;
            this.cancellationOrderStatusList = response.data.cancellation_order_status;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.axios
          .put("console/cancel_order/update-status", this.cancellationOrderForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Cancellation Order Update Status",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Cancellation Order Update Status");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    processCancel: function() {
      this.confirmCancelOrder = true;
      this.confirmCancelForm.reason = null;
    },
    processCancelSubmit: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin memproses permintaan ini ?")) {
        this.isLoading = true;
        this.confirmCancelForm.user_code = this.cancellationOrderForm.user_code;
        this.confirmCancelForm.order_number = this.cancellationOrderForm.order_number;
        this.confirmCancelForm.cancellation_order_id = this.cancellationOrderForm.id;
        this.axios
          .post("console/cancel_order/process", this.confirmCancelForm)
          .then((response) => {
            this.closeProcessCancel();
            this.showInfoNotification({
              title: "Cancellation Order Order Process",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Cancellation Order Order Process");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    closeProcessCancel: function() {
      this.confirmCancelOrder = false;
      this.confirmCancelForm.reason = null;
    }
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
